const postEventData = (path, formData) => {
  formData.append("authenticity_token", $('meta[name="csrf-token"]').attr("content"))

  if (navigator.sendBeacon) {
    try {
      navigator.sendBeacon(path, formData)
    } catch {
      console.warn(`Failed to send tracking event to ${path}`)
    }
  } else {
    $.ajax({
      url: path,
      data: formData,
      processData: false,
      contentType: false,
      type: "POST",
      success: function (response) {
        if (response && !response.success) {
          console.warn(`Failed to send tracking event to ${path}`)
        }
      },
    })
  }
}

const convertToFormData = (data) => {
  const formData = new FormData()
  Object.keys(data).forEach((key) => {
    formData.append(key, JSON.stringify(data[key]))
  })
  return formData
}

export const sendTrackingEvent = (eventName, eventBody) => {
  postEventData("/frontend_tracking/track_event", convertToFormData({ event_name: eventName, event_body: eventBody }))
}

export const sendTrackingEventBatch = (events) => {
  postEventData("/frontend_tracking/track_batch", convertToFormData({ events }))
}

export const getCookie = (name) => {
  if (document.cookie) {
    const match = document.cookie.split("; ").find((row) => row.startsWith(`${name}=`))

    if (match) {
      return match.split("=")[1]
    }

    return ""
  }

  return ""
}

export const getPageKey = () => {
  return (window.slideshare_object && window.slideshare_object.page_key) || null
}

export const getSlideshowId = () => {
  return (
    (window.slideshare_object && window.slideshare_object.slideshow && window.slideshare_object.slideshow.id) || "-1"
  )
}
